var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-symbols-rounded",style:(_vm.iconStyle)},[_vm._t("default"),(_vm.notHaveSlot)?[_vm._v(" "+_vm._s(_vm.name)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }